'use strict';

/**
 * Login service
 */
module.service('securityService', [ 'Restangular', '$q', '$window', 'Auth', function(Restangular, $q, $window, Auth) {

    
    /*
     * ------------------------------------------------------------------------------
     * SERVICE FUNCTIONS
     * -------------------------------------------------------------------------------
     */
	
	var sessionResource = Restangular.all('session');
	var responseUserLog = undefined;
    
    return {


        logOut : function() {
        	responseUserLog = undefined;
        	logout();
        },

        /**
         * 
         * @param role
         *            String that represent a rol or a secuence of roles
         *            separated by a coma
         * @returns {boolean}
         */
        hasRole : function(role) {
        	var roles = role.split(',');
        	var currentRoles = Auth.authz.realmAccess.roles; 
        	
            for (var i = 0; i < roles.length; i++) {
                for(var j = 0 ; j < currentRoles.length ; j++){
                    if(currentRoles[j] == roles[i]){
                    	return true;
                    }
                }
            }
            return false;
        },
        
        loadUserLoggedInfo : function() {
        	var deferred = $q.defer();
        	if(angular.isDefined(responseUserLog)){
        		deferred.resolve(responseUserLog);
        		return deferred.promise;
        	}
        	
            var answer = new restResponse();

            sessionResource.customGET('user', '').then(function(response) {
                answer.handleSuccessfullResponse(response, response.data);
                responseUserLog = response.data;
                deferred.resolve(response.data);
            }, function(response) {
                answer.handleErrorResponse(response, response.data);
                deferred.reject(answer);
            });
            return deferred.promise;
        },
        
        getLoggedUserId : function(){
        	return responseUserLog.id;
        }

    };
} ]);